<template>
    <div class="custom-card">
        <h4 class="mb-2">{{ nbComments }} commentaire{{ nbComments > 1 ? 's' : '' }}</h4>
        <DataTable :value="tableData" :paginator="paginator" :rows="10">
            <Column headerStyle="width: 1rem" />
            <Column field="date" header="Date">
                <template #body="slotProps">
                    <span>{{ slotProps.data.date }}</span>
                </template>
            </Column>
            <Column field="by" header="Par">
                <template #body="slotProps">
                    <span>{{ slotProps.data.createdBy }}</span>
                </template>
            </Column>
            <Column field="comment" header="Commentaire">
                <template #body="slotProps">
                    <span>{{ slotProps.data.comment }}</span>
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script lang="ts" setup>
import {ref, watch, PropType} from "vue";
import {UserBlacklistComment} from "@/models/blacklisting/UserBlacklistHistorique";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import moment from "moment";

const props = defineProps({
    data: {
        type: Array as PropType<UserBlacklistComment[]>,
        required: true,
    },
});
const paginator = ref<boolean>(false);
const tableData = ref(sortCommentsByDate(RemoveEmpty(props.data)));
const nbComments = ref(tableData.value.length);

watch(
    () => props.data,
    (newVal) => {
        tableData.value = sortCommentsByDate(RemoveEmpty(newVal));
        nbComments.value = tableData.value.length;
    }
);


if (nbComments.value > 10) {
    paginator.value = true;
}

function RemoveEmpty(data: UserBlacklistComment[]): UserBlacklistComment[] {
    return data.filter((item: UserBlacklistComment) => item.comment !== "");
}

function sortCommentsByDate(comments: UserBlacklistComment[]) {
    function parseFrenchDate(dateStr: string): Date {
        const format = "DD/MM/YYYY HH[h]mm";
        const date = moment(dateStr, format);
        return date.toDate();
    }

    return comments.sort(
        (a, b) =>
            parseFrenchDate(b.date).getTime() - parseFrenchDate(a.date).getTime()
    );
}
</script>

<style scoped lang="scss">

.custom-card {
    height: 300px;
    overflow-y: auto;
}
</style>